import React, { useState } from 'react';

const TermsAndConditionsModal = ({ onAccept }) => {
  const [accepted, setAccepted] = useState(false);

  const handleAccept = () => {
    if (accepted) {
      onAccept();
    }
  };

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center p-4 z-50">
      <div className="bg-white rounded-lg p-6 max-w-3xl w-full max-h-[90vh] overflow-y-auto">
        <h2 className="text-2xl font-semibold mb-4">Terms and Conditions</h2>
        <p className="text-sm text-gray-600 mb-6">Last Updated: February 9, 2025</p>
        
        <div className="prose prose-sm max-w-none mb-6">
          <p className="mb-4">
            Welcome to Going Green Cards ("the App"), developed and maintained by Going Green Advisors, LLC ("we," "our," or "us"). 
            By accessing or using the App, you agree to comply with and be bound by the following terms and conditions ("Terms"). 
            Please read them carefully before using the App.
          </p>

          <h3 className="text-lg font-semibold mt-6 mb-2">1. Educational Purpose</h3>
          <p>The Going Green Cards App was created for educational purposes only. The content, tools, and resources provided within the App are intended to promote learning and engagement around sustainability and environmentally conscious practices. The information provided is not intended as professional advice or guidance.</p>

          <h3 className="text-lg font-semibold mt-6 mb-2">2. Acceptance of Terms</h3>
          <p>By using the App, you acknowledge that you have read, understood, and agreed to these Terms and any future modifications. If you do not agree with any part of these Terms, you must not access or use the App.</p>

          <h3 className="text-lg font-semibold mt-6 mb-2">3. User Responsibilities</h3>
          <p>You agree to use the App responsibly and in compliance with applicable laws and regulations. You are responsible for any activity that occurs under your user account (if applicable).</p>

          <h3 className="text-lg font-semibold mt-6 mb-2">4. Content Ownership and Usage</h3>
          <p>All content, features, and materials available on the App, including but not limited to text, graphics, logos, and software, are the property of Going Green Advisors, LLC or licensed to us. You may use the content solely for personal, educational purposes. Unauthorized copying, distribution, or commercial use is prohibited.</p>

          <h3 className="text-lg font-semibold mt-6 mb-2">5. Third-Party Content</h3>
          <p>The App may contain links or references to third-party websites or services. We do not endorse or assume responsibility for any third-party content, products, or services.</p>

          <h3 className="text-lg font-semibold mt-6 mb-2">6. Disclaimer of Warranties</h3>
          <p>The App is provided "as is" and "as available" without any warranties of any kind, either express or implied, including but not limited to warranties of merchantability, fitness for a particular purpose, or non-infringement. We do not guarantee that the App will be uninterrupted or error-free.</p>

          <h3 className="text-lg font-semibold mt-6 mb-2">7. Limitation of Liability</h3>
          <p>To the fullest extent permitted by law, Going Green Advisors, LLC shall not be liable for any indirect, incidental, special, or consequential damages arising from or related to your use of the App. This includes, but is not limited to, damages for loss of profits, data, or goodwill.</p>

          <h3 className="text-lg font-semibold mt-6 mb-2">8. Release of Claims</h3>
          <p>By using the App, you release and hold harmless Going Green Advisors, LLC, its members, affiliates, and employees from any and all claims, liabilities, damages, or losses arising from your use of the App.</p>

          <h3 className="text-lg font-semibold mt-6 mb-2">9. Changes to the Terms</h3>
          <p>We reserve the right to update or modify these Terms at any time. Changes will be effective immediately upon posting on the App. Your continued use of the App after any such changes constitutes your acceptance of the new Terms.</p>

          <h3 className="text-lg font-semibold mt-6 mb-2">10. Termination</h3>
          <p>We may terminate or suspend your access to the App at any time, without prior notice, if you violate these Terms or if we deem it necessary to protect the integrity of the App.</p>

          <h3 className="text-lg font-semibold mt-6 mb-2">11. Governing Law</h3>
          <p>These Terms shall be governed by and construed in accordance with the laws of the State of New York, without regard to its conflict of law principles.</p>

          <h3 className="text-lg font-semibold mt-6 mb-2">12. Contact Us</h3>
          <p>If you have any questions about these Terms or the App, please contact us at:</p>
          <p>Going Green Advisors, LLC<br />josh@goinggreen.earth</p>
        </div>

        <div className="flex flex-col gap-4 border-t pt-4">
          <label className="flex items-start gap-2">
            <input
              type="checkbox"
              checked={accepted}
              onChange={(e) => setAccepted(e.target.checked)}
              className="mt-1"
            />
            <span className="text-sm">
              I have read and agree to the Terms and Conditions
            </span>
          </label>

          <button
            onClick={handleAccept}
            disabled={!accepted}
            className="w-full bg-[#04b53a] text-white py-2 rounded hover:bg-[#039431] disabled:opacity-50 disabled:cursor-not-allowed"
          >
            Accept and Continue
          </button>
        </div>
      </div>
    </div>
  );
};

export default TermsAndConditionsModal;